<template>
  <a-menu-item :key="menuInfo.key" v-bind="$props" v-on="$listeners" :disabled="menuInfo.disabled">
    <a-tooltip placement="bottomRight" :title="(!store_url || !is_storeactive) && $t('topBar.waitingApproval')" trigger="click">
      <a v-if="menuInfo.url === 'store_url'" @click="openStore">
        <span :class="[styles.title, (!store_url || !is_storeactive) && 'text-muted']">{{ menuInfo.key === 'order-list' && menuInfo.roles.includes('distributor') ? $t(`sideBar.orderListDistributor`) : $t(`sideBar.${menuInfo.lang}`) }}</span>
        <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
        <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
      </a>
    </a-tooltip>
    <router-link v-if="menuInfo.url && menuInfo.url !== 'store_url'" :to="menuInfo.url">
      <span :class="styles.title">{{ menuInfo.key === 'order-list' && menuInfo.roles.includes('distributor') ? $t(`sideBar.orderListDistributor`) : $t(`sideBar.${menuInfo.lang}`) }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </router-link>
    <span v-if="!menuInfo.url" :to="menuInfo.url">
      <span :class="styles.title">{{ menuInfo.key === 'order-list' && menuInfo.roles.includes('distributor') ? $t(`sideBar.orderListDistributor`) : $t(`sideBar.${menuInfo.lang}`) }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </span>
  </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'
import { mapState } from 'vuex'

export default {
  name: 'SubMenu',
  props: {
    ...Menu.Item.props,
    menuInfo: Object,
    styles: Object,
  },
  computed: {
    ...mapState('user', {
      store_url: state => state.store_url,
      is_storeactive: state => state.is_storeactive,
    }),
  },
  methods: {
    openStore () {
      if (!this.store_url || !this.is_storeactive) {
        return
      }

      window.open(this.store_url, '_blank')
    },
  },
}
</script>
